import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import LabeledSimpleInput from '~/components/Form/LabeledSimpleInput'
import WinItButton from '~/components/WinItButton'
import Spacer from '~/components/Spacer'
import Center from '~/components/basic/Center'
import { buildEnrichedAuthReturnUrl } from '~/utilities/buildAuthReturnUrl'

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
`

const SuccessText = styled.p`
  color: ${(props) => props.theme.colors.text.subContent};
  font-size: 0.95rem;
  text-align: center;
  margin: 0;
`

const SwitchLink = styled.button`
  display: inline;
  border: none;
  background: none;
  padding: 0;
  font-size: 0.85em;
  color: #8a8a8a;
  cursor: pointer;
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  &:hover {
    text-decoration: underline;
  }
`

@inject((all) => ({
  auth: all.store.auth,
  store: all.store,
  email: all.store.auth.email,
  isAttemptingMagicLinkRequest: all.store.auth.isAttemptingMagicLinkRequest,
  magicLinkEmailSent: all.store.auth.magicLinkEmailSent,
}))
@observer
class MagicLinkLogin extends Component {
  handleChange = (event) => {
    this.props.auth.changeKey('email', event.target.value.trim().toLowerCase())
  }

  handleSubmit = (event) => {
    if (event?.preventDefault) event.preventDefault()
    this.props.auth.requestLoginMagicLink(buildEnrichedAuthReturnUrl(this.props.store))
  }

  render() {
    const { auth, email, isAttemptingMagicLinkRequest, magicLinkEmailSent } = this.props
    const emailError = auth.validateDisplayMessage('email')

    if (magicLinkEmailSent) {
      return (
        <>
          <SuccessText>
            We sent a login link and 6-digit code to this email. Check your inbox and spam folder.
          </SuccessText>
          {this.props.onShowCodeForm ? (
            <>
              <Spacer mobile={10} desktop={10} />
              <Center>
                <SwitchLink type="button" onClick={this.props.onShowCodeForm}>
                  Enter code from email
                </SwitchLink>
              </Center>
            </>
          ) : null}
        </>
      )
    }

    return (
      <FormContainer onSubmit={this.handleSubmit}>
        <LabeledSimpleInput
          label="Email"
          disabled={isAttemptingMagicLinkRequest}
          onChange={this.handleChange}
          value={email}
          error={emailError}
          autoFocus={false}
        />
        <Spacer mobile={15} desktop={15} />
        <WinItButton
          onClick={this.handleSubmit}
          disabled={isAttemptingMagicLinkRequest}
          type="submit"
        >
          {isAttemptingMagicLinkRequest ? 'Sending...' : 'Continue'}
        </WinItButton>
        {this.props.onShowCodeForm ? (
          <>
            <Spacer mobile={10} desktop={10} />
            <Center>
              <SwitchLink type="button" onClick={this.props.onShowCodeForm}>
                Have a code from your email?
              </SwitchLink>
            </Center>
          </>
        ) : null}
      </FormContainer>
    )
  }
}

export default MagicLinkLogin
